import type { OrderCardMountData } from '../../../../global_state/src/cardLayersReducer';

// This is used to open a card without fetching order groups and its orders. It's used for easy development by opening a card with real data.
const realOrderCardMountData: OrderCardMountData = {
    brand: { brandNumber: '04', brandName: 'Jack & Jones', isPrimary: false },
    order: {
        businessTradingPartner: null,
        collection: {
            collectionNumber: 54553,
            collectionName: '2026 EXPRESS 1-2-3',
            collectionTerm: 'EX26 1-3',
            isDeleted: false,
        },
        composition: {
            composition: 'Cotton - Organic 100%',
            hasBom: false,
            isBomValid: false,
        },
        createdDate: new Date('2025-10-09'),
        earliestCargoClosingDate: new Date('2025-12-31'),
        factory: {
            companyName: 'GMS Composite Knitting Industry Ltd.',
            companyNumber: '1004',
            isDeleted: false,
        },
        isKeyCustomer: false,
        isPackingNoteTransmitted: false,
        isPreliminaryOrder: false,
        isReadyForLabelProduction: true,
        issuer: {
            isDeleted: false,
            issuerName: 'Bestseller A/S',
            issuerNumber: 104,
            issuerShortName: 'DENMARK',
        },
        keyOrder: null,
        orderCode: 'GMSNLG4483203',
        orderNumber: 4540604,
        orderState: {
            isDeleted: false,
            orderStateName: 'Confirmed',
            orderStateNumber: 3,
            orderStateTypeName: 'CONFIRMED',
        },
        quantity: 18720,
        style: {
            styleName: 'CANVAS TEE BLK7526',
            styleNumber: 12257526,
        },
        supplier: {
            companyName: 'GMS Composite Knitting Industry Ltd ',
            companyNumber: '400579',
            isDeleted: false,
        },
    },
};

export { realOrderCardMountData };
